/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import classnames from 'classnames'

import Paper from 'material-ui/Paper'

import CardTitle from './CardTitle'
import 'resources/styles/card/Card.css'

const Card = (props) => (
  <Paper
    zDepth={2}
    className={classnames('Card', props.className)}
    style={props.style}
  >
    {
      props.title
        ? <CardTitle
          rightIcon={props.rightIcon}
          rightIconClick={props.rightIconClick}
          subTitle={props.subTitle}
          actions={props.actions}
        >
          {props.title}
        </CardTitle>
        : null
    }
    {
      props.children
    }
  </Paper>
)

export default Card



// WEBPACK FOOTER //
// ./src/generic/card/Card.js